const stepsList = {
  GROUP_SELECTION: 'GROUP_SELECTION',
  INFO_GROUP: 'INFO_GROUP',
  INFO_PERSONAL: 'INFO_PERSONAL',
  PHONE_CHECK: 'PHONE_CHECK',
  FEEDBACK_SUCCESS: 'FEEDBACK_SUCCESS',
  ATTACH_MEDICAL_REQUEST: 'ATTACH_MEDICAL_REQUEST'
}

export { stepsList }